module.exports = __webpack_public_path__ + "static/media/hexagonz.859312ba.png";